import { useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';
import { scrollPageToTop } from '../../utils/scrolling';
const ReactRouterScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useLayoutEffect(() => {
    scrollPageToTop();
  }, [pathname]);
  return null;
};
export default ReactRouterScrollToTop;